// extracted by mini-css-extract-plugin
export default {"propertyReadOnly":"_kta6","items":"fYZ7Q","item":"BwYX3","value":"qr2Pd","icon":"dgpSk"};